import OtpEntry from '@shared/components/auth/OtpEntry';

const OtpCOnfig = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false,
				},
				toolbar: {
					display: false,
				},
				footer: {
					display: false,
				},
			},
		},
	},
	routes: [
		{
			path: '/otp',
			component: OtpEntry,
		},
	],
};

export default OtpCOnfig;
